import {
  PROJECT_USER_ROLES,
  PROJECT_USER_STATE
} from "../constants/projectUser";
import { NEAR_ENDING_PREMIUM, PREMIUM } from "../constants/premiumState";
import {
  CURRENCY,
  PROJECT_ID,
  PROJECT_USER_ID,
  PROJECT_USER_ROLE,
  USER_IS_OWNER
} from "../constants/storageKeys";
import { CUSTODIAN_PANEL, NON_CUSTODIAN_PANEL } from "../constants/panelTypes";
import { getNormalizedProjectUserTeams } from "./normalizedProjectUserTeams";
import { history } from "../configureStore";
import Store from "../configureStore";
import { loginUserActiveRolesInGivenProjects } from "./checkAccess";
import {
  PanelSelectionModalAction,
  PremiumFeatureAction,
  PremiumGuestAction
} from "../actions";
import {
  banAccessMessage,
  buyNewPremiumPlanByAdminMessage
} from "../constants/messages";
import { getUserNameWithMobile } from "./getUserIdentification";
import { getQueryStringValue } from "../sagas/auth";

export const checkIsOwner = (projectOwner, userId) => {
  return projectOwner.id === userId;
};
const getActiveProjectsForLoginUser = (projectUsers, user) => {
  return projectUsers.filter(
    projectUser =>
      projectUser.state === PROJECT_USER_STATE.ACTIVE &&
      projectUser.user_id === user.id
  );
};
const checkProjectIsPremium = premiumState => {
  return premiumState === PREMIUM || premiumState === NEAR_ENDING_PREMIUM;
};

export const goToProject = (projectUserObj, projectObj, replace, link) => {
  const projectUserId = projectUserObj.id;
  const isOwner = checkIsOwner(projectObj.owner, projectUserObj.user_id);
  const userRole = projectUserObj.user_type;
  const lastProjectUserId = parseInt(localStorage.getItem(PROJECT_USER_ID));
  const currencyObj = projectObj.currency;
  if (lastProjectUserId !== projectUserId) {
    localStorage.setItem(PROJECT_USER_ID, projectUserId);
    localStorage.setItem(PROJECT_ID, projectObj.id);
    localStorage.setItem(USER_IS_OWNER, isOwner);
    localStorage.setItem(PROJECT_USER_ROLE, userRole);
    localStorage.setItem(CURRENCY, currencyObj.symbol_fa);
    let redirect = getQueryStringValue("redirect");
    const destination = link ? link : redirect ? redirect : "/";
    history.replace(destination);
    window.location.reload();
  }
};

export const hasOtherTeams = project => {
  const user = Store.getState().User.data;
  const activeProjectUsers = getActiveProjectsForLoginUser(
    project.project_users,
    user
  );
  const custodianProjectUsers = activeProjectUsers.filter(
    projectUser => projectUser.user_type === PROJECT_USER_ROLES.CUSTODIAN
  );
  getCurrentProjectUserTeam(project);
  return custodianProjectUsers.length > 1;
};

export const getCurrentProjectUserTeam = project => {
  const normalizedProjectUserTeams = getNormalizedProjectUserTeams(
    project.teams,
    project.project_users
  );
  const currentProjectUserId = parseInt(localStorage.getItem(PROJECT_USER_ID));
  for (let i = 0; i < normalizedProjectUserTeams.length; i++) {
    const pr = normalizedProjectUserTeams[i];
    if (pr.id === currentProjectUserId) {
      return panelText(pr, ":");
    }
  }
};

export const panelText = (projectUser, connector) => {
  if (projectUser.user_type === PROJECT_USER_ROLES.CUSTODIAN) {
    const custodianTeam = projectUser.project_user_teams;
    let teamName = "";
    if (custodianTeam.length === 1) {
      teamName = custodianTeam[0].name;
    }
    return `پنل تنخواه‌داری${connector} ${teamName}`;
  } else {
    return `پنل مدیریت`;
  }
};

export const selectProjectUser = project => {
  const user = Store.getState().User.data;
  const activeProjectUsers = getActiveProjectsForLoginUser(
    project.project_users,
    user
  );
  const loginUserRolesInThisProject = loginUserActiveRolesInGivenProjects(
    activeProjectUsers
  );
  const isOwnerInThisProject = loginUserRolesInThisProject.includes(
    PROJECT_USER_ROLES.OWNER
  );
  if (isOwnerInThisProject || checkProjectIsPremium(project.premium_state)) {
    let selectedProjectUser;
    if (activeProjectUsers.length === 1) {
      // it can be owner, custodian, manager, admin
      // goto project
      selectedProjectUser = activeProjectUsers[0];
    } else {
      let redirect = getQueryStringValue("redirect");
      const custodianProjectUsers = activeProjectUsers.filter(
        projectUser => projectUser.user_type === PROJECT_USER_ROLES.CUSTODIAN
      );
      if (custodianProjectUsers.length === 1 && redirect === "") {
        //go to it
        selectedProjectUser = custodianProjectUsers[0];
      } else {
        const nonCustodianProjectUsers = activeProjectUsers.filter(
          projectUser => projectUser.user_type !== PROJECT_USER_ROLES.CUSTODIAN
        );
        let normalizedCustodianProjectUsers = getNormalizedProjectUserTeams(
          project.teams,
          custodianProjectUsers
        );
        normalizedCustodianProjectUsers = normalizedCustodianProjectUsers || [];
        //let user choose between projectUsers

        const selectableProjectUsers = [
          ...nonCustodianProjectUsers,
          ...normalizedCustodianProjectUsers
        ];
        Store.dispatch(
          PanelSelectionModalAction.modalData({
            project: project,
            projectUsers: selectableProjectUsers
          })
        );
        // history.push({
        //   pathname: PANEL_SELECTION,
        //   state: { project: project, projectUsers: selectableProjectUsers }
        // });
      }
    }
    if (selectedProjectUser) {
      goToProject(selectedProjectUser, project);
    }
  } else {
    showDialogOnSelectedNotOwnNotPremiumProject(
      loginUserRolesInThisProject,
      project
    );
  }
};

export const showDialogOnSelectedNotOwnNotPremiumProject = (
  loginUserRolesInThisProject,
  project
) => {
  const isAdminInThisProject = loginUserRolesInThisProject.includes(
    PROJECT_USER_ROLES.ADMIN
  );
  if (isAdminInThisProject) {
    const message = buyNewPremiumPlanByAdminMessage(
      getUserNameWithMobile(project.owner)
    );
    Store.dispatch(
      PremiumFeatureAction.modalData(
        { message, ownerId: project.owner.id },
        false
      )
    );
  } else {
    const message = banAccessMessage(project.name);
    Store.dispatch(
      PremiumGuestAction.modalData({
        message,
        owner: project.owner,
        projectId: project.id
      })
    );
  }
};

export const getPanel = () => {
  const projectUserRole = parseInt(localStorage.getItem(PROJECT_USER_ROLE));
  let panel = CUSTODIAN_PANEL;
  if (projectUserRole && projectUserRole !== PROJECT_USER_ROLES.CUSTODIAN) {
    panel = NON_CUSTODIAN_PANEL;
  }
  return panel;
};
